import {Injectable} from "@angular/core";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {Message} from "./message.model";
import {TranslateService} from "@ngx-translate/core";

/**
 * Service for sending messages and storing them
 */
@Injectable()
export class MessageService {
    private _message: Subject<Message>;
    public message$: Observable<Message>;
    private _messages: ReplaySubject<Array<Message>>;
    public messages: Array<Message>;
    public messages$: Observable<Array<Message>>;

    constructor(private translate: TranslateService) {
        this._message = new Subject<Message>();
        this.message$ = this._message.asObservable();
        this._messages = new ReplaySubject<Array<Message>>(1);
        this.messages = new Array<Message>();
        this.messages$ = this._messages.asObservable();
    }

    /**
     * Remove an existing notification
     * @param {Notification} notification
     */
    complete(id: string): void {
        this.messages.forEach((message) => {
            if (message.id === id) {
                this.messages.splice(this.messages.indexOf(message), 1);
            }
        });

        this._messages.next(this.messages);
    }

    /**
     * Send a new notification
     * @param {string} notification
     */
    send(message: Message): void {
        this.translate.get(message.title, {value: message.value}).subscribe((translation: string) => {
            message.title = translation;
        });

        let found: boolean = false;
        for (let i = 0; i < this.messages.length; i++) {
            if (this.messages[i].id === message.id) {
                this.messages[i] = message;
                found = true;
                break;
            }
        }

        if (!found) {
            this.messages.unshift(message);
        }

        this._messages.next(this.messages);
    }
}
